import React from 'react';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';

import Button from '@dashboard/components/Button';
import Link from '@dashboard/components/Link';
import { Card } from '@dashboard/components/ui/card';
import { Separator } from '@dashboard/components/ui/separator';

const AddBookingLayout: React.FC<{
  onBack?: () => void;
  event?: React.ReactNode;
  children: React.ReactNode;
}> = ({ onBack, event, children }) => (
  <div className="mx-auto mt-8 mb-36 w-full max-w-screen-2xl px-4 sm:px-16">
    <div className="absolute top-6 left-4">
      <Button appearance="light" onClick={onBack} aria-label="Back to the event">
        <ChevronLeftIcon className="h-5 w-5" />
      </Button>
    </div>

    <div className="mx-auto mt-20 mb-20 w-full max-w-lg">
      <div className="mb-8 space-y-1 text-center">
        <h1 className="text-xl text-balance">Add booking</h1>
        <p className="text-sm text-muted-foreground">
          Create a booking on behalf of a customer.{' '}
          <Link
            href="/docs/articles/how-to-manually-add-an-event-booking"
            target="_blank"
            color="default"
            blank
          >
            Learn more
          </Link>
        </p>
      </div>

      <Card className="p-5">
        {event && (
          <>
            {event}
            <Separator className="my-4" />
          </>
        )}
        {children}
      </Card>
    </div>
  </div>
);

export default AddBookingLayout;
